var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var TDCheckbox = createReactClass({
	propTypes: {
		// no id means that this is a new item
		id: PropTypes.node,
		type: PropTypes.string,
		value: PropTypes.bool,
		placeholder: PropTypes.string,
		onChange: PropTypes.func.isRequired
	},
	change: function() {
		this.props.onChange({
			action: (typeof this.props.id !== 'undefined') ? "change" : "add",
			id: this.props.id,
			type: this.props.type,
			value: !(this.props.value)
		});
	},
	render: function() {
		return (
			<td className="text-center">
				<div className="">
					<input
						name={this.props.id + " " + this.props.type}
						className=""
						type="checkbox"
						checked={this.props.value}
						onChange={this.change}
						disabled={this.props.disabled}
					/>
				</div>
			</td>
		)
	}
});

module.exports = TDCheckbox;
